<template>
  <div class="c-text-between  c-flex-wrap " style="margin-top: -90px;position: relative;">
    <!-- Rectangle 2203.jpg -->
    <!-- <img src="@/assets/images/diana/201009_V2_P4_duerr 1.jpg" alt="" style="    height: 100%; max-width: 100%;"> -->
    <!-- <picture>
      <source media="(max-width: 899px)" srcset="@/assets/images/diana/Rectangle2203.jpg">
      <img src="@/assets/images/diana/201009_V2_P4_duerr 1.jpg" alt="" style="height: auto; width: 100%;">
    </picture> -->
    <picture>
      <source media="(max-width: 899px)" srcset="@/assets/images/diana/Rectangle2203.jpg">
      <img src="@/assets/images/diana/201009_V2_P4_duerr 1.jpg" alt="" style="height: 100%; width: 100%; object-fit: cover;" loading="lazy">
    </picture>
    <div  class="c-pos-absolute  c-text-column c-text-pack c-width-diana" style="height: 100%;left: 5%;">
      <h2 class="c-text-left" style="font-size: 28px;color: white;margin-bottom: 10px ;">AGILE ROBOTS 的DIANA 7  </h2>
      <span class="c-text-left c-mb-10">力感应机器人 Diana 7 的七自由度、高精度和直观简洁的操作界面，使用户无需高级编程技能，即可轻松快速上手操作。</span>
      <span class="c-text-left c-mb-10">FCI（Franka Control Interface）的引入，使用户能够绕过软件层，直接访问机器人的控制算法，让 Diana 7 也适用于对负载要求高的科研应用场景。</span>
      <!-- <div> -->
        <router-link to="/contact" class="buttonSite">联系我们</router-link>
      <!-- </div> -->
    </div>
    
    <h2 class="c-text-left c-width-min  px-container" 
    style="font-size: 40px;color: white;margin-bottom: 10px ;position: absolute;
    bottom: 0;">AGILE ROBOTS 的DIANA 7  </h2>
  </div>
   
  <div class="c-text-column c-back"> 
    <div  class=" px-container  c-width-min   c-mt-40" style="height: 100%;">
      <!-- <h2 class="c-text-left" style="font-size: 28px;color: white;margin-bottom: 10px ;">AGILE ROBOTS 的DIANA 7  </h2> -->
      <div class="c-text-left c-mb-10">力感应机器人 Diana 7 的七自由度、高精度和直观简洁的操作界面，使用户无需高级编程技能，即可轻松快速上手操作。</div>
      <div class="c-text-left c-mb-10">FCI（Franka Control Interface）的引入，使用户能够绕过软件层，直接访问机器人的控制算法，让 Diana 7 也适用于对负载要求高的科研应用场景。</div>
      <!-- <div class="buttonSite"> -->
        <router-link to="/contact"  class="buttonSite">联系我们</router-link>
      <!-- </div> -->
    </div>
    <div class="line-with-text px-container">
      <hr class="divider">
      <span class="line-text">主要规格</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">
      <div class="display-width c-text-column c-mb-10" style="align-items: flex-start; justify-content: center;">
        <strong>高效覆盖</strong>
        <span class="c-mt-5 c-mb-10 c-text-left text-indent">Diana 7 拥有 923 mm 臂展范围，能够在不同距离内高效完成拾取和放置任务。</span>

        <strong>极致精度</strong>
        <span class="c-mt-5 c-mb-10 c-text-left text-indent">Diana 7 凭借精确的速度控制，重复定位精度可达 0.05 mm，确保其卓越的操作精度。</span>

        <strong>高度灵活</strong>
        <span class="c-mt-5 c-mb-10 c-text-left text-indent">凭借 七自由度设计，Diana 7
          具备极高的灵活性和操作性。第七轴使其运动更平滑，能够更好地绕过障碍物，并在狭小或复杂空间内展现更强的适应能力。</span>

        <strong>强大负载能力</strong>
        <span class="c-mt-5 c-mb-10 c-text-left text-indent">Diana 7 的有效负载高达 7 kg ，非常适合搬运不同重量和尺寸的物体。</span>

        <div class="linkTag">
          <a href="https://www.agile-robots.com/media/files/products/diana-7/Agile-Robots_Diana_7_Tech-Data-Sheet.pdf"
            target="_blank">下载Diana7数据表</a>
        </div>
      </div>
      <div class="display-width c-mb-10">
        <img src="@/assets/images/diana/imagecompanion.jpg" alt="" style="    height: auto; max-width: 100%;">
      </div>
    </div>

    <div class="c-text-vBetween c-pos-relative ">
      <img src="@/assets/images/diana/201009_V2_P4_duerr 2.jpg" alt="" style="    height: auto; max-width: 100%;">
    </div>

    <div class="line-with-text px-container ">
      <hr class="divider">
      <span class="line-text">精通复杂任务操作</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap " style="margin-bottom: 80px;">

      <div class="display-width c-mb-10">
        <img src="@/assets/images/diana/imagecompanion-2.jpg" alt="" style="    height: auto; max-width: 100%;">
      </div>
      <div class="display-width c-text-column c-mb-10" style="align-items: flex-start; justify-content: center;">
        <strong>易用</strong>
        <span class="c-mt-5 c-mb-10 c-text-left text-indent">依托思灵机器人自主研发的智能软件AgileCore，Diana 7
          可轻松被安装，集成，编程，维护及维修。</span>

        <strong>直观</strong>
        <span class="c-mt-5 c-mb-10 c-text-left text-indent">仿生运动学设计与用户友好界面，使用户操作流畅，尤其在教学新任务和调整位置时更加便捷。</span>

        <strong>灵敏</strong>
        <span class="c-mt-5 c-mb-10 c-text-left text-indent">七个轴均配备力矩传感器，让 Diana 7 成为市场上最灵活、最灵敏的机器人手臂之一。</span>

        <strong>多功能</strong>
        <span class="c-mt-5 c-mb-10 c-text-left text-indent">凭借七轴设计、高精度及灵活编程，Diana 7 适应多种应用场景，兼具高级控制与直观软件，操作简单高效。</span>

        <div class="linkTag">
          <a href="https://www.agile-robots.com/media/files/products/diana-7/Agile-Robots_Diana_7_Brochure.pdf"
            target="_blank">产品手册下载</a>
        </div>
      </div>

    </div>

    <div class="line-with-text px-container ">
      <hr class="divider">
      <span class="line-text">FRANKA 控制接口 (FCI)</span>
      <hr class="divider">
    </div>
    <div class="c-text-between px-container c-flex-wrap" style="margin-bottom: 80px;">
      <div class="display-width c-text-column c-mb-10" style="align-items: flex-start; justify-content: center;">
        <h2 style="font-size: 28px;text-align: left;">Diana7现全面适配FCI接口 - FRANKA CONTROL INTERFACE </h2>
        <span class="c-mt-5 c-mb-10 c-text-left text-indent">FCI 接口 让研究人员能够直接访问机器人控制算法，支持用户 以1 kHz 的频率发送实时指令，实现高精度控制：
          关节空间：位置、速度、力矩 ；笛卡尔空间：位置、速度、力。

        </span>

        <span class="c-mt-5 c-mb-10 c-text-left text-indent">精准控制，释放Diana7的无限可能！</span>
        <div class="linkTag">
          <!-- <a href="http://10.15.1.204:9002/" target="_blank">FCI文件</a> -->
          <a href="https://frankaemika.github.io/docs/" target="_blank">FCI文件</a>
        </div>
      </div>
      <div class="display-width c-mb-10">
        <img src="@/assets/images/diana/image 55.jpg" alt="" style="    height: auto; max-width: 100%;">
      </div>
    </div>

    <div class="c-text-align c-pos-relative c-bottom-height ">

      <img src="@/assets/images/diana/image 36.jpg" alt="" style="    height: 100%; max-width: 100%;">
      <div class="c-pos-absolute  c-text-column" style="left: 50%;">
        <h2 style="font-size: 28px;color: white;margin-bottom: 10px ;">对 DIANA 7 感兴趣吗？</h2>
        <!-- <div class="buttonSite"> -->
          <router-link to="/contact" class="buttonSite">联系我们</router-link>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
    metaInfo() {
        return {
          title: this.$route.meta.title, // 从路由获取标题
          meta: [
            { 
              name: 'keywords', 
              content: this.$route.meta.metaTags[0]['content']
            }
          ]
        }
      },
  name: 'roductsDiana',
  components: {
    // HelloWorld
  },
  data() {
    return {
    }
  },
}
</script>
<style scoped>
.c-bottom-height {
  height: 400px;
}

.c-back {
  background: #2a2b38;
  color: white
}
.divider{
  border-top: 1px solid white !important;
}
.c-width-diana{
  width: 30%;
}
.c-width-min{
  display: none;
}
/* 屏幕宽度小于 900px 时，一行展示 2 个 */
@media (max-width: 999px) {
  .c-bottom-height {
    height: 200px;
  } 
}
@media (max-width: 899px) {
  .c-width-diana {
    display: none;
  }
  .c-width-min{
    display: inline-block;
  }
}

/* 屏幕宽度小于 600px 时，一行展示 1 个 */
@media (max-width: 599px) {}
</style>
